/**
 * Used in V1 and V2 Intake
 * 
 * This component corresponds to the following templates:
 * views/telemedicine/intakes/insurances/_insurance_select.html.erb
 * views/telemedicine/intakes/v2/insurances/_insurance_select.html.erb
 */

const OTHER_SELECTION = 'Other'
const FREE_INSURANCE_PROVIDERS = [
  'United Healthcare - Medicare Advantage',
  'Piedmont Select - Medicare Advantage'
]

export class InsuranceSelect {
  constructor(el) {
    this.dropdown = el.querySelector('[data-insurance-dropdown]')
    this.alternate = el.querySelector('[data-insurance-alt]')
    this.disclaimer = el.querySelector('[data-insurance-disclaimer]')

    this.dropdown.addEventListener('change', this.render.bind(this))
    this.render()
  }

  get selection() {
    return this.dropdown.value
  }

  get needsAlternate() {
    return this.selection === OTHER_SELECTION
  }

  render() {
    if (this.needsAlternate) {
      this.alternate.classList.remove('hidden')
      if (this.disclaimer) {
        this.disclaimer.classList.remove('hidden')
      }
    } else {
      this.alternate.classList.add('hidden')
      if (this.disclaimer) {
        this.disclaimer.classList.add('hidden')
      }
    }

    this.alternate.disabled = !this.needsAlternate

    let copayField = document.querySelector("[data-component='copay-input']")

    if (FREE_INSURANCE_PROVIDERS.indexOf(this.selection) > -1){
      copayField.value = 0
    } else {
      copayField.value = copayField.dataset.copayvalue
    }
  }
}
